import { createMuiTheme } from '@material-ui/core/styles';

import { breakpoints } from './breakpoints';
import { overrides } from './overrides';
import { palette } from './palette';
import { props } from './props';
import { spacing } from './spacing';
import { typography } from './typography';

export const theme = createMuiTheme({
  breakpoints,
  overrides,
  palette,
  props,
  spacing,
  typography,
});
